

import { Card, CardContent } from "@/components/ui/card";
import React from "react";

export interface StatCardProps {
    label: string;
    value: number | string | null | undefined;
    icon?: React.ReactNode;
    valueColorClass?: string; // e.g. "text-green-600"
    iconWrapperClass?: string; // wrapper bg color
}

export default function StatCard({
    label,
    value,
    icon,
    valueColorClass = "text-gray-900",
    iconWrapperClass = "bg-gray-100",
}: StatCardProps) {
    // Edge-case handling
    const displayValue =
        value === null || value === undefined || value === "" ? "—" : value;

    return (
        <Card className="bg-white border border-gray-200 shadow-sm">
            <CardContent className="p-4 sm:p-6">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-sm font-medium text-gray-600">{label}</p>
                        <p className={`text-xl sm:text-2xl font-bold ${valueColorClass}`}>
                            {displayValue}
                        </p>
                    </div>

                    <div
                        className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center ${iconWrapperClass}`}
                    >
                        {icon ?? null}
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
